import React, { useState } from "react";
import "./verify-bank-account.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  selectCurrentOrganization,
  clearNotifications,
  selectOrganizationNotifications,
  verifyOrganizationBankAccount
} from "../../reducers/organizationSlice";
import { getBankAccountVerificationForm } from "../../forms/BankAccountForm";
import { useFormValidation } from "../../hooks/formHooks";
import { useNotificationBanner, useNotificationNavigation } from "../../hooks/notificationHooks";
import { longDelay } from "../../helpers/JSONapi";

const VerifyBankAccount = () => {
  const [context, isValid, setIsValid] = useFormValidation(false);
  const selectedOrganization = useSelector(selectCurrentOrganization);
  const orgNotifications = useSelector(selectOrganizationNotifications);
  const [amounts, setAmounts] = useState({verifyAmountOne: 0, verifyAmountTwo: 0});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useNotificationNavigation("saved", orgNotifications, `/${selectedOrganization.id}/settings/payments`);

  const verifyAmounts = () => {
    if (isValid) {
      setIsValid(false);
      dispatch(verifyOrganizationBankAccount({ ...amounts, organizationId: selectedOrganization.id }));
    }
  };

  context.updateAmounts = (value, property) => {
    setIsValid(true);
    let obj = { ...amounts };
    obj[property] = value;
    setAmounts(obj);
  };

  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };

  context.setIsValid = setIsValid;
  context.amounts = amounts;

  const leftNavigation = () => {
    dispatch(clearNotifications());
    navigate(-1);
  };

  const getActions = () => {
    let actions = [
      {
        name: "verify account",
        action: verifyAmounts,
        isDisabled: !isValid,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Account Verification",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return <GSForm formTitle="Verify Bank Account" formSections={getBankAccountVerificationForm(context)}></GSForm>;
  };
  
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const [banner] = useNotificationBanner({notifications: orgNotifications, timeoutAction, timeout: longDelay});

  return (
    <verify-bank-account>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      />
    </verify-bank-account>
  );
};

export default VerifyBankAccount;
